import { atomWithStorage } from 'jotai/utils';

/**
 * One-shot flag for DEV-6530's "first download" usage journey. Set to `true`
 * only when the user answers "My own content" and their download starts
 * (DEV-6626) — not when the step merely opens, so closing the modal without
 * answering re-offers the question on the next download. It is never set for
 * "Company or client content": those are business users who should see the
 * try-it-free reminder on every download.
 *
 * Persisted to `localStorage` (not session) so the rule holds across visits:
 * once an own-content download has gone through, the *following* download —
 * even in a later session — falls back to the regular download journey.
 */
export const firstDownloadUsageSeenAtom = atomWithStorage<boolean>(
  'ub:first-download-usage-seen',
  false
);
